// import httpService from '@/services/httpService';
import commonUtil from '@/utils/commonUtil'
import httpService from './httpService'

const serverPath = window.location.origin;
const arsmoApi = '/arsmo_api';
const CommonService = {
  authLoginWithWX: () => {
    let appId = commonUtil.getAppId();
    //window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_auth&state=STATE&redirect_uri=`;
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${serverPath}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
  },
  getWXJSAPISignature: (param) => {
    const url = `${serverPath}${arsmoApi}/js_sdk/signature`;
    return httpService.httpPost(url, param)
  }
}

export default CommonService



// WEBPACK FOOTER //
// ./src/services/common-service.js